import { Colors } from "@/constants/Colors"
import { semanticColor } from "@/theme/emo-coach-theme"
import { View } from "react-native"

const particles = [
  { left: "8%", top: "7%", size: 1, opacity: 0.14, color: Colors.dark.primary },
  { left: "18%", top: "29%", size: 1, opacity: 0.1, color: Colors.dark.textPrimary },
  { left: "34%", top: "13%", size: 1, opacity: 0.1, color: semanticColor("skill") },
  { left: "58%", top: "9%", size: 1, opacity: 0.12, color: Colors.dark.primary },
  { left: "74%", top: "31%", size: 1, opacity: 0.09, color: semanticColor("proof") },
  { left: "90%", top: "16%", size: 1, opacity: 0.12, color: Colors.dark.textPrimary },
  { left: "12%", top: "72%", size: 1, opacity: 0.09, color: semanticColor("growth") },
  { left: "84%", top: "78%", size: 1, opacity: 0.1, color: semanticColor("proof") },
] as const

export function GlowField() {
  return (
    <View className="absolute inset-0 overflow-hidden" style={{ pointerEvents: "none" }}>
      <View className="absolute inset-0" style={{ backgroundColor: Colors.dark.surface }} />
      {particles.map((particle, index) => (
        <View
          key={index}
          className="absolute rounded-sm"
          style={{
            left: particle.left,
            top: particle.top,
            height: particle.size,
            width: particle.size,
            backgroundColor: particle.color,
            opacity: particle.opacity,
          }}
        />
      ))}
    </View>
  )
}
